import { useCallback, useState } from 'react';

// maybe replace by useCollapsibleOverlay
export function usePopup() {
  const [resultsOpen, setResultsOpen] = useState(false);

  const closeResults = useCallback(() => {
    setResultsOpen(false);
  }, []);

  const openResults = useCallback(() => {
    setResultsOpen(true);
  }, []);
  return {
    resultsOpen,
    openResults,
    closeResults,
  };
}
